import React from 'react'
import './loader.css';
const CustomLoader = () => {
  return (
    <div className="loader-overlay">
    <div className="loader"></div>
  </div>
  )
}

export default CustomLoader